import React from "react";
import { achievements } from "../../data/impactStories";
import { FileCheck } from "lucide-react";

export default function RiStats() {
  return (
    <section id="numbers" data-testid="ri-stats" className="py-24 lg:py-32 bg-[#F5D000] relative overflow-hidden grain scroll-mt-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative z-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14 reveal">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-black/60 mb-4">The Record</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.02] text-black">
              Achievements,<br />not projections.
            </h2>
          </div>
          <p className="text-black/70 max-w-md leading-relaxed text-sm lg:text-base">
            No progress bars, no vanity metrics. Each figure links to the evidence behind it,
            and only changes when reality does.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-black/15 rounded-2xl overflow-hidden border border-black/15">
          {achievements.map((a, i) => (
            <a
              key={a.id}
              href="#reports"
              data-testid={`achievement-${a.id}`}
              className="reveal group bg-[#F5D000] p-8 lg:p-10 hover:bg-[#FFE34D] transition-colors duration-300 flex flex-col"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="font-heavy text-4xl lg:text-5xl text-black mb-3 leading-none">{a.value}</div>
              <div className="font-display text-lg font-bold text-black mb-1.5">{a.label}</div>
              <div className="text-sm text-black/60 mb-6">{a.sub}</div>
              <div className="mt-auto inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] font-bold text-black/60 group-hover:text-black transition-colors">
                <FileCheck className="w-3.5 h-3.5" /> Evidence: {a.evidence}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
